import { render, staticRenderFns } from "./TransportLoadedItemsTable.vue?vue&type=template&id=4d9da392"
import script from "./TransportLoadedItemsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TransportLoadedItemsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports